import styled from '@emotion/styled';

export const ModalContainer = styled.div`
  .form-field {
    margin-bottom: 20px;
  }

  .form-field label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
  }

  .form-field input,
  .form-field textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    font-family: inherit;
  }

  .form-field input:focus,
  .form-field textarea:focus {
    outline: none;
    border-color: #2185d0;
    box-shadow: 0 0 0 2px rgba(34, 133, 208, 0.2);
  }

  .form-field textarea {
    min-height: 120px;
    resize: vertical;
  }

  .error {
    color: #db2828;
    font-size: 14px;
    margin-top: 5px;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }

  .info-text {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    font-style: italic;
  }
`;
